import { api } from "../../api";

export type SpSlotRow = {
    id: number;
    start_time: string;
    end_time: string;
    label: string;
    is_added: number | string | boolean;
};

export type GetSpSlotsResponse = {
    success: boolean;
    message?: string;
    results?: SpSlotRow[];
};

export type SpSlotAvailabilityEntry = {
    date: string;
    time_slot: number[];
};

export type SaveSpSlotAvailabilitiesRequest = {
    slot: SpSlotAvailabilityEntry[];
};

export const spAvailabilityApi = api.injectEndpoints({
    endpoints: (build) => ({
        getSpSlots: build.query<GetSpSlotsResponse, { date: string }>({
            query: ({ date }) => ({
                url: "/v1/service-provider/slots",
                params: { date },
            }),
            providesTags: (_result, _error, { date }) => [
                { type: "SpSlots", id: date },
            ],
        }),
        saveSpSlotAvailabilities: build.mutation<
            GetSpSlotsResponse,
            SaveSpSlotAvailabilitiesRequest
        >({
            query: (body) => ({
                url: "/v1/service-provider/slot-availabilities",
                method: "POST",
                body,
                headers: {
                    "Content-Type": "application/json",
                },
            }),
            invalidatesTags: (_result, _error, arg) =>
                (arg.slot ?? []).map((s) => ({
                    type: "SpSlots" as const,
                    id: s.date,
                })),
        }),
    }),
    overrideExisting: false,
});

export const {
    useGetSpSlotsQuery,
    useSaveSpSlotAvailabilitiesMutation,
} = spAvailabilityApi;
